import { render, staticRenderFns } from "./SolutionCenter.vue?vue&type=template&id=15bbdcc8&scoped=true"
import script from "./SolutionCenter.vue?vue&type=script&lang=js"
export * from "./SolutionCenter.vue?vue&type=script&lang=js"
import style0 from "./SolutionCenter.vue?vue&type=style&index=0&id=15bbdcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbdcc8",
  null
  
)

export default component.exports